const sections = {
  BasicDetails: {
    value: 'BASIC_DETAILS',
    label: 'contractor.form.basicDetails'
  },
  CompanyAddress: {
    value: 'COMPANY_ADDRESS',
    label: 'contractor.form.companyAddress'
  },
  CorrespondenceAddress: {
    value: 'CORRESPONDENCE_ADDRESS',
    label: 'contractor.form.correspondenceAddress'
  },
  AdditionalDetails: {
    value: 'ADDITIONAL_DETAILS',
    label: 'contractor.form.additionalDetails'
  },
  FinanceDetails: {
    value: 'FINANCE_DETAILS',
    label: 'contractor.form.financialDetails'
  },
  Files: {
    value: 'FILES',
    label: 'contractor.form.files'
  },
}
export default sections
